var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "map map-indoor",
      class: { "map-alpha": _vm.alpha },
      attrs: { id: "mapIndoor" },
    },
    [
      _c(
        "div",
        { staticClass: "absolute z-10 left-2 bottom-2" },
        [
          _c(
            "Btn",
            {
              class: "no-hover",
              attrs: { title: _vm.$t("plans.buildingLegend") },
              nativeOn: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.setAlpha(true)
                },
                mouseup: function ($event) {
                  $event.stopPropagation()
                  return _vm.setAlpha(false)
                },
                mouseout: function ($event) {
                  $event.stopPropagation()
                  return _vm.setAlpha(false)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-building" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "marker marker-ghost",
          staticStyle: {
            width: "50px",
            height: "50px",
            position: "absolute",
            "z-index": "100",
            "pointer-events": "none",
            top: "-50px",
            left: "-50px",
            display: "none",
          },
          attrs: { id: "marker-ghost" },
        },
        [
          _c("img", {
            staticStyle: { width: "50px", height: "50px" },
            attrs: { src: _vm.markerWifi },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "marker-popup",
        staticStyle: {
          position: "absolute",
          "z-index": "100",
          top: "-50px",
          left: "-50px",
          display: "none",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }